// This is an offline-safe "needs backup" marker, NOT financial data.
// Scoped to an authenticated BPA user and stored in same-origin localStorage.
const PREFIX='bpa-expense-google-dirty-v1:';
export const localDirtyMarker=userId=>{
 if(!userId||typeof localStorage==='undefined')return '';
 try{return localStorage.getItem(PREFIX+userId)||''}catch{return ''}
};
export function markLocalDirty(userId){
 if(!userId||typeof window==='undefined')return;
 const marker=Date.now().toString(36)+'-'+(typeof crypto!=='undefined'&&crypto.randomUUID
   ?crypto.randomUUID():Math.random().toString(36).slice(2));
 try{localStorage.setItem(PREFIX+userId,marker)}catch(e){
   console.warn('Could not persist Google backup pending marker',e);
 }
 window.dispatchEvent(new CustomEvent('bpa:finance-mutated',{detail:{userId}}));
}
export function acknowledgeLocalDirty(userId,expectedMarker){
 if(!userId||typeof localStorage==='undefined')return false;
 try{
   if(localDirtyMarker(userId)!==expectedMarker)return false;
   localStorage.removeItem(PREFIX+userId);
   return true;
 }catch{return false}
}
export function signalGoogleReady(){
 if(typeof window!=='undefined')window.dispatchEvent(new Event('bpa:google-ready'));
}